// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContributionRecordBulkUpdateRequestDto
 */
export interface IContributionRecordBulkUpdateRequestDto {
    /**
     * New employee (EE) contribution amount applied to all records
     * @type {number}
     * @memberof IContributionRecordBulkUpdateRequestDto
     */
    ee_amount?: number;
    /**
     * New employer (ER) contribution amount applied to all records
     * @type {number}
     * @memberof IContributionRecordBulkUpdateRequestDto
     */
    er_amount?: number;
    /**
     * New contribution date applied to all records
     * @type {Date}
     * @memberof IContributionRecordBulkUpdateRequestDto
     */
    date?: Date | null;
    /**
     * New tax year applied to all records
     * @type {string}
     * @memberof IContributionRecordBulkUpdateRequestDto
     */
    tax_year?: string;
    /**
     * New tax type applied to all records
     * @type {string}
     * @memberof IContributionRecordBulkUpdateRequestDto
     */
    tax_type?: IContributionRecordBulkUpdateRequestDtoTaxTypeEnum;
    /**
     * Memo to set for all records
     * @type {string}
     * @memberof IContributionRecordBulkUpdateRequestDto
     */
    memo?: string | null;
}

/**
* @export
* @enum {string}
*/
export enum IContributionRecordBulkUpdateRequestDtoTaxTypeEnum {
    PRE_TAX = 'PRE_TAX',
    POST_TAX = 'POST_TAX'
}


/**
 * Check if a given object implements the IContributionRecordBulkUpdateRequestDto interface.
 */
export function instanceOfIContributionRecordBulkUpdateRequestDto(value: object): value is IContributionRecordBulkUpdateRequestDto {
    return true;
}

export function IContributionRecordBulkUpdateRequestDtoFromJSON(json: any): IContributionRecordBulkUpdateRequestDto {
    return IContributionRecordBulkUpdateRequestDtoFromJSONTyped(json, false);
}

export function IContributionRecordBulkUpdateRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionRecordBulkUpdateRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ee_amount': json['ee_amount'] == null ? undefined : json['ee_amount'],
        'er_amount': json['er_amount'] == null ? undefined : json['er_amount'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'tax_year': json['tax_year'] == null ? undefined : json['tax_year'],
        'tax_type': json['tax_type'] == null ? undefined : json['tax_type'],
        'memo': json['memo'] == null ? undefined : json['memo'],
    };
}

export function IContributionRecordBulkUpdateRequestDtoToJSON(json: any): IContributionRecordBulkUpdateRequestDto {
    return IContributionRecordBulkUpdateRequestDtoToJSONTyped(json, false);
}

export function IContributionRecordBulkUpdateRequestDtoToJSONTyped(value?: IContributionRecordBulkUpdateRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ee_amount': value['ee_amount'],
        'er_amount': value['er_amount'],
        'date': value['date'] === null ? null : ((value['date'] as any)?.toISOString().substring(0,10)),
        'tax_year': value['tax_year'],
        'tax_type': value['tax_type'],
        'memo': value['memo'],
    };
}

